import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "How do I book a transfer?", a: "Simply enter your pick-up and drop-off locations in the booking form, select the number of passengers, and choose your preferred vehicle. You'll see instant pricing and can complete your reservation online." },
  { q: "What airports do you cover?", a: "We cover all major airports in the Dominican Republic: Punta Cana (PUJ), Santo Domingo (SDQ), Santiago (STI), La Romana (LRM), Puerto Plata (POP), and Samaná (AZS)." },
  { q: "Can I cancel or modify my booking?", a: "Yes! Free cancellation is available up to 24 hours before your scheduled pick-up. Modifications can be made anytime by contacting our support team." },
  { q: "What tours do you offer?", a: "We offer a wide range of tours including island excursions (Saona, Catalina), whale watching in Samaná, city tours in Santo Domingo, adventure tours like buggy rides, and more. Check our Tours page for the full catalog." },
  { q: "How is the price calculated?", a: "Transfer prices are based on zones and vehicle type with fixed rates. Tour prices vary by experience and duration. Round trip transfers receive a discount." },
  { q: "Are your drivers licensed?", a: "Absolutely. All Always On Time drivers are professionally licensed, fully vetted, and trained to provide a safe, comfortable experience. Vehicles are insured and regularly maintained." },
];

const FAQSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <p className="text-primary font-semibold text-sm uppercase tracking-widest mb-2">
            FAQ
          </p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
            >
              <AccordionItem
                value={`item-${i}`}
                className="border border-border rounded-lg px-5 bg-white hover:border-primary/20 transition-all"
              >
                <AccordionTrigger className="text-foreground font-semibold text-left text-sm hover:no-underline hover:text-primary">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
